import React from 'react';
import CustomLink from './link';

const Button = ({ size, url, emoji, children, theme }) => {
	const btnTheme = theme === 'default' || !theme ? '' : `btn--${theme}`;
	return (
		<CustomLink url={url} classes={`btn btn--${size} ${btnTheme}`}>
			{emoji?.url !== undefined && (
				<img className='emoji' src={emoji.url} alt={emoji.alt} />
			)}
			<span className='btn-text'>{children}</span>
		</CustomLink>
	);
};
export default Button;
